import { signupFormWithAnalyticsSchema } from "@redotech/redo-model/signup-form-schema";
import { z } from "zod";

export const getSignupFormById = {
  input: z.object({ formId: z.string() }),
  output: signupFormWithAnalyticsSchema,
};
